module.exports = __webpack_public_path__ + "img/Metadata.08e39d1c.webp";